import React, { useState, useEffect } from "react";
import { Grid, Divider, Button, Header } from "semantic-ui-react";
import { useNavigate } from "react-router-dom";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import axios from "axios";
import { BaseUrl, BaseUrlInvoice } from "../formcomponents/Constants";

import Swal from "sweetalert2";

import { reduxForm, Field } from "redux-form";
import { userData } from "../store/userData";
const ContactCatList = (props) => {
  const { handleSubmit, pristine, reset, submitting } = props;
  const navigate = useNavigate();
  const [rowData, setrowData] = useState([]);
  const userDetail = userData();
  useEffect(() => {
    getWorkCatList();
  }, []);

  const getWorkCatList = () => {
    axios
      .post(BaseUrlInvoice + "accounts/listSSCategory", {
        categoryType: 4,
      })
      .then((res) => {
        console.log("res", res.data);
        setrowData(res.data);
      })
      .catch((error) => console.log(error));
  };

  const columnDefs = [
    { headerName: "Visa Category", field: "categoryName" },
    {
      headerName: "Action",
      field: "categoryId",
      cellRendererFramework: (params) => (
        <div>
          <Button color="primary" onClick={() => actionButton(params)}>
            edit
          </Button>{" "}
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          {userDetail.userRole == 1 && (
            <Button color="red" onClick={() => deleteItem(params)}>
              delete
            </Button>
          )}
        </div>
      ),
    },
  ];

  const deleteItem = (params) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        // Swal.fire("Deleted!", "Your file has been deleted.", "success");
        axios
          .post(BaseUrlInvoice + "accounts/deleteSSCategory", {
            categoryId: params.data.categoryId,
          })
          .then((res) => {
            console.log(res.data);
            Swal.fire("Deleted!", " Category has been deleted.", "success");
            getWorkCatList();
          })
          .catch((error) => {
            console.log(error);
          });
      }
    });
  };
  const actionButton = (params) => {
    // console.log("Params", params.data);
    navigate(
      `/create-contact-category/${params.data.categoryId}/${params.data.categoryType}`
    );
  };
  const defaultColDef = {
    sortable: true,
    editable: true,
    flex: 1,
    filter: true,
    floatingFilter: true,
  };
  const catogeryItems = [
    { value: 1, text: "Spend Money" },
    { value: 2, text: "Receive Money" },
    { value: 3, text: "Company List" },
  ];
  return (
    <div>
      <Grid.Row>
        <Header dividing size="huge" as="h1">
          Contact category List
        </Header>
      </Grid.Row>
      <Divider hidden /> <Divider hidden />
      <Grid columns="two">
        <Grid.Row>
          <Grid.Column>
            <div
              style={{
                marginTop: "20px",
              }}
            >
              <Button
                type="submit"
                primary
                onClick={() => navigate("/create-contact-category/null/null")}
              >
                Create New
              </Button>
            </div>
          </Grid.Column>
        </Grid.Row>
      </Grid>
      <Divider hidden /> <Divider />
      <div className="ag-theme-alpine" style={{ height: 600 }}>
        <AgGridReact
          rowData={rowData}
          columnDefs={columnDefs}
          defaultColDef={defaultColDef}
          pagination={true}
        ></AgGridReact>
      </div>
    </div>
  );
};

export default reduxForm({
  form: "ContactCatList",
})(ContactCatList);
